import type { Identifier, XYCoord } from 'dnd-core'
import loadingImage from "./loading.gif"
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { FC, useEffect, useRef, useState } from 'react';
import { Trash } from 'tabler-icons-react';

export const ImageItem = (props: { id: number, file: File, index: number, removeCard: (index: number) => void }) => {
    const [image, setImage] = useState("")

    useEffect(() => {
        if (image == "") {
            let reader = new FileReader()

            reader.readAsDataURL(props.file)

            reader.onloadend = function (e) {
                if (reader.result instanceof Error) {
                } else if (reader.result instanceof ArrayBuffer) {
                } else {
                    setImage(reader.result!)
                }

            }
        }
    }, [props.file])

    return <div className="card bg-dark border-0 text-white mb-2" style={{position:"relative"}}>
        {image == "" ?
            <img className="card-img" src={loadingImage} style={{ height: "170px" }} />
            :
            <><div style={{position: "absolute", top: 5, right: 15, color: "red", cursor: "pointer"}} onClick={()=>props.removeCard(props.index)}><Trash  /></div>
            <img className="card-img" src={image} alt="Card image" /></>}
    </div>
}

export interface CardProps {
    id: any
    text: any
    index: number
    moveCard: (dragIndex: number, hoverIndex: number) => void
}

interface DragItem {
    index: number
    id: string
    type: string
}

export const Card: FC<CardProps> = ({ id, text, index, moveCard }) => {
    const ref = useRef<HTMLDivElement>(null)
    const [{ handlerId }, drop] = useDrop<
        DragItem,
        void,
        { handlerId: Identifier | null }
    >({
        accept: "card",
        collect(monitor) {
            return {
                handlerId: monitor.getHandlerId(),
            }
        },
        hover(item: DragItem, monitor) {
            if (!ref.current) {
                return
            }
            const dragIndex = item.index
            const hoverIndex = index

            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return
            }

            // Determine rectangle on screen
            const hoverBoundingRect = ref.current?.getBoundingClientRect()

            // Get vertical middle
            const hoverMiddleY =
                (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2

            // Determine mouse position
            const clientOffset = monitor.getClientOffset()

            // Get pixels to the top
            const hoverClientY = (clientOffset as XYCoord).y - hoverBoundingRect.top

            // Only perform the move when the mouse has crossed half of the items height
            // When dragging downwards, only move when the cursor is below 50%
            // When dragging upwards, only move when the cursor is above 50%


            // Time to actually perform the action
            moveCard(dragIndex, hoverIndex)

            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            item.index = hoverIndex
        },
    })

    const [{ isDragging }, drag] = useDrag({
        type: "card",
        item: () => {
            return { id, index }
        },
        collect: (monitor: any) => ({
            isDragging: monitor.isDragging(),
        }),
    })

    const opacity = isDragging ? 0 : 1
    drag(drop(ref))
    return (
        <div ref={ref} style={{ opacity }} className="col-md-4 col-xl-2" data-handler-id={handlerId}>
            {text}
        </div>
    )
}